import './autosize';
import './bind_in_out';
import './details_behavior';
import installGlEmojiElement from './gl_emoji';
import './quick_submit';
import './requires_input';
import './toggler_behavior';

installGlEmojiElement();



// WEBPACK FOOTER //
// ./behaviors/index.js